import {FormShoppingCart} from 'Documents/api';
import {MarketingViewCart} from '../ducks/Marketing';
import {FormOrderRequestDto} from '../models/Marketing';

export const mapToFormOrderRequestDto = (cart: MarketingViewCart) => {
  const requestDto = <FormOrderRequestDto>{
    formOrderShipping: {
      address1: cart.address,
      address2: cart.address2,
      caseNameNumber: cart.accountNumber,
      city: cart.city,
      company: cart.company,
      costCenter: cart.costCenter ? cart.costCenter : null,
      email: cart.email,
      fedExName: cart.fedExName,
      fedExNumber: cart.fedExNumber,
      notes: cart.instructions,
      phone: cart.phoneNumber,
      shipMode: cart.shipPriority,
      shipTo: cart.firstName?.concat(cart.lastName ? ' ' : '', cart.lastName ? cart.lastName : ''),
      state: cart.state,
      zipCode: cart.zip,
    },
    formShoppingCartList: [],
  };

  cart.items.forEach(cartItem => {
    const item = <FormShoppingCart>{
      fid: cartItem.fId,
      quantity: cartItem.quantity,
    };

    requestDto.formShoppingCartList?.push(item);
  });

  return requestDto;
};
